"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AUTH_ERROR_UNKNOWN = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var AUTH_ERROR_UNKNOWN = "AUTH_ERROR_UNKNOWN";
exports.AUTH_ERROR_UNKNOWN = AUTH_ERROR_UNKNOWN;
var AuthError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(AuthError, _Error);
  var _super = _createSuper(AuthError);
  function AuthError(message) {
    var _this;
    (0, _classCallCheck2.default)(this, AuthError);
    _this = _super.call(this, message || "An unknown error occurred");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "code", void 0);
    _this.code = AUTH_ERROR_UNKNOWN;
    return _this;
  }
  return AuthError;
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var _default = AuthError;
exports.default = _default;